<template>
  <section id="RenewalDeadline" :class="position">
    <b-container>
      <div class="left">
        <p>Your United Club Seat Extension Deadline is Approaching!</p>
        <h3>Extend By Oct 21st!</h3>
        <Countdown/>
        <!-- <div class="extend-btn" v-b-modal.expiringModal>Extend Now</div> -->
      </div>
    </b-container>
  </section>
</template>

<script>
import Countdown from "@/components/global/Countdown";
import BeyondPopup from "@/components/global/BeyondInvoicePopup";
import ExtensionPopup from "@/components/global/ExtensionPopup";
import RenewPopup from "@/components/global/RenewPopup";
import { mapState } from "vuex";

export default {
  name: "RenewalDeadline",
  props: ["position"],
  components: {
    Countdown,
    ExtensionPopup,
    BeyondPopup,
    RenewPopup
  },
  computed: {
    ...mapState(["global"]),
  },
};
</script>

<style lang="scss" scoped>
#RenewalDeadline {
  position: relative;
  background: url("~@/assets/bg/bg-renew-deadline.png") scroll no-repeat top right #FF4B00;
  background-size: cover;
  width: 100%;
  padding: 100px 0;
  .container {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    .left {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 390px;
      h3 {
        max-width: 320px;
        font-size: 42px;
        @include nofex;
        line-height: 36px;
        text-transform: uppercase;
        // color: #092244;
        color: #FFF;
      }
      p {
        max-width: 320px;
        margin-bottom: 28px;
        @include nexaBold;
        font-size: 15px;
        line-height: 22px;
        text-transform: uppercase;
        color: #ffffff;
      }
      .extend-btn {
        cursor: pointer;
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 10px 20px;
        margin-top: 28px;
        text-decoration: none;
        font-size: 13px;
        @include nexaBold;
        line-height: 18px;
        text-align: center;
        text-transform: uppercase;
        width: 178px;
        height: 33px;
        background: url("~@/assets/bg/white-btn-bg.png") scroll no-repeat center center;
        background-size: 178px 33px;
        color: $dark-blue;
      }
    }
  }
}
</style>

<style lang="scss">
#renewalModalOrange,
#renewalModalBlue {
  .modal-dialog {
    width: 100vw;
    max-width: 100vw;
  }
  .modal-content {
    width: 100vw;
    background-color: transparent;
    border: none;
    overflow: auto;
    padding-top: 15px;
  }
  .modal-body {
    align-items: center;
    padding: 0;
    width: fit-content;
    margin: auto;
  }
  .close {
    position: absolute;
    top: -18px;
    right: 7px;
    height: 36px;
    width: 36px;
    opacity: 1;
    cursor: pointer;
    z-index: 999;
    &.fancybox-close {
      background-image: url("~@/assets/icons/fancybox_sprite.png");
    }
  }
}
</style>